/* eslint-disable react-hooks/exhaustive-deps */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import CustomButton from "common/components/Button/Button"
import Modal from "common/components/Modal/Modal"
import { QUERY_PARAMETERS } from "common/constants"
import useOnClickOutside from "common/hooks/useOnClickOutside"
import {
  checkArrayLengthWithoutTipoPrestamo,
  formatDate,
} from "common/utils/utils"
import { AnimatePresence } from "framer-motion"
import moment from "moment"
import { Button } from "primereact/button"
import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import FechaFilter from "./components/FechaFilter"
import ImporteFilter from "./components/ImporteFilter"
import {
  DATE_YYYY_MM_DD,
  LAST_ACTIVITY_OPTIONS,
  PERSONALIZADO_OPTION,
  getFechasFilter,
  getImporteFilter,
  getLabelFechasFilter,
  getRangedLabel,
  getValidDate,
} from "./constants"
import "./style.scss"

const FilterMenu = ({
  initialMinPrecioRange = 0,
  initialMaxPrecioRange = 10000,
  handleFilter,
  resetFilters,
  onConfirmFilters,
  icon = "bars-filter",
  buttonColor = "",
  dateFilterKeys = [
    QUERY_PARAMETERS.FechaLowerLimit,
    QUERY_PARAMETERS.FechaUpperLimit,
  ],
  importeFilterKeys = [
    QUERY_PARAMETERS.ImporteLowerLimit,
    QUERY_PARAMETERS.ImporteUpperLimit,
  ],
  lastDate,
  startDate,
  importeFilterActive,
  fechaFilterActive,
  fechaDrodownActive = true,
  importeSliderActive = true,
  children,
  customFilterTitle,
  getDate,
  handleRemoveFilter,
  isActiveinitialBadge = true,
  disableDateTag,
  selectedOptions = [],
  extraResetQuerys = [],
  endCustomChildren,
  seeButonDates = true,
  applyAlwaysActive = false,
  isCustomFilterActive = false,
  preDataFilter,
  customFunction,
  setSelectedOptions,
  query = "",
  setQuery,
  notUpdateImport = true,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const ref = useRef()
  const location = useLocation()
  const [showFilterMenu, setShowFilterMenu] = useState(false)
  const [isFilterActive, setIsFilterActive] = useState(
    isCustomFilterActive ||
      checkArrayLengthWithoutTipoPrestamo(selectedOptions, location.pathname)
  )
  // @ts-expect-error TS(2554): Expected 4 arguments, but got 2.
  useOnClickOutside(ref, () => setShowFilterMenu(false))

  const [labelDate, setLabelDate] = useState("")
  const [badgeLabel, setBadgeLabel] = useState(
    getLabelFechasFilter(preDataFilter?.selectedOptions) || ""
  )
  const [rangeDateOption, setRangeDateOption] = useState("")

  const [preData, setPredata] = useState({
    date: getValidDate(
      preDataFilter?.selectedOptions,
      startDate,
      lastDate,
      dateFilterKeys
    ),
    [importeFilterKeys[0]]:
      getImporteFilter(preDataFilter?.selectedOptions)?.ImporteLowerLimit ||
      initialMinPrecioRange,
    [importeFilterKeys[1]]:
      getImporteFilter(preDataFilter?.selectedOptions)?.ImporteUpperLimit ||
      initialMaxPrecioRange,
    rangeDateOption,
    preciosRange: [initialMinPrecioRange, initialMaxPrecioRange],
    labelDate,
    badgeLabel,
    selectedOptions,
    query,
  })
  const [precioLowerLimit, setPrecioLowerLimit] = useState(
    getImporteFilter(preDataFilter?.selectedOptions)?.ImporteLowerLimit ||
      initialMinPrecioRange
  )
  const [precioUpperLimit, setPrecioUpperLimit] = useState(
    getImporteFilter(preDataFilter?.selectedOptions)?.ImporteUpperLimit ||
      initialMaxPrecioRange
  )
  const [date, setDate] = useState(
    getValidDate(
      preDataFilter?.selectedOptions,
      startDate,
      lastDate,
      dateFilterKeys
    )
  )

  const [preciosRange, setPreciosRange] = useState([
    initialMinPrecioRange,
    initialMaxPrecioRange,
  ])

  useEffect(() => {
    const lowerLimit = startDate?._i
      ? formatDate(startDate?._i, "YYYY-MM-DD")
      : startDate?._d
      ? formatDate(startDate?._d, "YYYY-MM-DD")
      : ""
    const upperLimit = lastDate?._d
      ? formatDate(lastDate?._d, "YYYY-MM-DD")
      : lastDate?._i
      ? formatDate(lastDate?._i, "YYYY-MM-DD")
      : ""
    setDate({
      [dateFilterKeys[0]]: lowerLimit,
      [dateFilterKeys[1]]: upperLimit,
    })
  }, [])

  const openFilters = () => {
    setShowFilterMenu(!showFilterMenu)
  }

  const setDefaultFilterDates = () => {
    const rangeQuery = `${dateFilterKeys[0]}=${startDate.format(
      DATE_YYYY_MM_DD
    )}${dateFilterKeys[1]}=${lastDate.format(DATE_YYYY_MM_DD)}`
    handleFilter(
      [rangeQuery],
      dateFilterKeys[0] || QUERY_PARAMETERS.FechaLowerLimit,
      true
    )
  }

  const setDefaultFilterLabel = () => {
    const rangeDate = getRangedLabel(startDate, lastDate)
    setBadgeLabel(rangeDate)
    if (
      [
        ROUTES.CONTABILIDAD_BALANCE,
        ROUTES.CONTABILIDAD_PERDIDAS_GANANCIAS,
        ROUTES.CONTABILIDAD_SUMAS_SALDOS,
      ].includes(location.pathname)
    ) {
      setIsFilterActive(true)
    }
  }

  useEffect(() => {
    if (startDate && lastDate && isActiveinitialBadge) {
      setDefaultFilterLabel()
      setDefaultFilterDates()
    }
  }, [])

  const handleOnChangeLowerPrecioRange = (e: $TSMigrationFixMe) => {
    setPrecioLowerLimit(e.value)
    const rangeQuery = `${importeFilterKeys[0]}=${e.value}${importeFilterKeys[1]}=${precioUpperLimit}`
    handleFilter([rangeQuery], importeFilterKeys[1], true)
    if (precioLowerLimit < precioUpperLimit) {
      setPreciosRange([e.value, precioUpperLimit])
    }
  }

  const handleOnChangeHigherPrecioRange = (e: $TSMigrationFixMe) => {
    setPrecioUpperLimit(e.value)
    const rangeQuery = `${importeFilterKeys[0]}=${precioLowerLimit}${importeFilterKeys[1]}=${e.value}`
    handleFilter([rangeQuery], importeFilterKeys[1], true)
    if (precioUpperLimit > precioLowerLimit) {
      setPreciosRange([precioLowerLimit, e.value])
    }
  }

  const setRangeDatesFilter = (newState: $TSMigrationFixMe) => {
    const rangeQuery = `${dateFilterKeys[0]}=${newState[dateFilterKeys[0]]}${
      dateFilterKeys[1]
    }=${newState[dateFilterKeys[1]]}`
    handleFilter(
      [rangeQuery],
      dateFilterKeys[0] || QUERY_PARAMETERS.FechaLowerLimit,
      true
    )
  }
  const updatePrecioRange = (reset: $TSMigrationFixMe) => {
    if (notUpdateImport) {
      handleOnChangeLowerPrecioRange({
        value: reset ? initialMinPrecioRange : precioLowerLimit,
      })
      handleOnChangeHigherPrecioRange({
        value: reset ? initialMaxPrecioRange : precioUpperLimit,
      })
    }
  }
  const handleCustomDate = (
    e: $TSMigrationFixMe,
    queryParam: $TSMigrationFixMe
  ) => {
    setLabelDate("")
    setRangeDateOption("")
    const newState = {
      ...date,
      [queryParam]: e.target.value,
    }
    setDate(newState)
    setRangeDatesFilter(newState)
  }

  const handleDate = (e: $TSMigrationFixMe) => {
    e.originalEvent && setLabelDate(e.originalEvent.target?.ariaLabel)
    setRangeDateOption(e.target.value)
    const newState = {
      [dateFilterKeys[0]]: e.target.value,
      [dateFilterKeys[1]]: moment(Date.now()).format(DATE_YYYY_MM_DD),
    }
    setDate(newState)
    setRangeDatesFilter(newState)
  }

  const handleChangePrecioRange = ({ value }: $TSMigrationFixMe) => {
    const [min, max] = value
    setPreciosRange(value)
    setPrecioLowerLimit(min)
    setPrecioUpperLimit(max)
    const rangeQuery = `${importeFilterKeys[0]}=${min}${importeFilterKeys[1]}=${max}`
    handleFilter([rangeQuery], importeFilterKeys[1], true)
  }

  const onGetSelectValues = () => {
    const list = LAST_ACTIVITY_OPTIONS(t).map((activity) => {
      return {
        label: activity.label,
        value: activity.value.status,
      }
    })
    return [
      ...list,
      {
        label: PERSONALIZADO_OPTION(t),
        value: "",
      },
    ]
  }
  const menuRef = useRef()

  const hide = () => {
    openFilters()
  }

  const handleConfirmFilters = () => {
    updatePrecioRange(false)
    setPredata({
      date,
      [importeFilterKeys[0]]: precioLowerLimit,
      [importeFilterKeys[1]]: precioUpperLimit,
      rangeDateOption,
      preciosRange,
      labelDate,
      badgeLabel,
      selectedOptions,
      query,
    })
    customFunction?.confirmFilter()
    openFilters()
    onConfirmFilters()
    setIsFilterActive(true)
    // @ts-expect-error TS(2538): Type 'any[]' cannot be used as an index type.
    const existDateRange = Boolean(date[[dateFilterKeys[1]]])
    if (existDateRange && !rangeDateOption) {
      const rangeDate = getRangedLabel(
        // @ts-expect-error TS(2538): Type 'any[]' cannot be used as an index type.
        date[[dateFilterKeys[0]]],
        // @ts-expect-error TS(2538): Type 'any[]' cannot be used as an index type.
        date[[dateFilterKeys[1]]]
      )
      setBadgeLabel(rangeDate)
      setLabelDate("")
    } else {
      setBadgeLabel(labelDate)
    }
  }
  const onClearFilters = () => {
    setShowFilterMenu(false)
    setIsFilterActive(false)
    resetFilters([
      QUERY_PARAMETERS.Estado,
      QUERY_PARAMETERS.intervalo,
      dateFilterKeys[0],
      dateFilterKeys[1],
      importeFilterKeys[0],
      importeFilterKeys[1],
      QUERY_PARAMETERS.ImporteAmortizacionLowerLimit,
      QUERY_PARAMETERS.ImporteAmortizacionUpperLimit,
      ...extraResetQuerys,
    ])
    setIsFilterActive(false)
    setDate({
      [dateFilterKeys[0]]: "",
      [dateFilterKeys[1]]: "",
    })
    setLabelDate("")
    setBadgeLabel("")
    setRangeDateOption("")
    getDate?.("Invalid date")
    setQuery("")
    setPredata({
      date: {
        [dateFilterKeys[0]]: "",
        [dateFilterKeys[1]]: "",
      },
      [importeFilterKeys[0]]: initialMinPrecioRange,
      [importeFilterKeys[1]]: initialMaxPrecioRange,
      rangeDateOption: "",
      preciosRange: [initialMinPrecioRange, initialMaxPrecioRange],
      query: "",
      badgeLabel: "",
      labelDate: "",
      selectedOptions: [],
    })
    setBadgeLabel("")
    updatePrecioRange(true)
    handleChangePrecioRange({
      value: [initialMinPrecioRange, initialMaxPrecioRange],
    })
    setSelectedOptions([])
    customFunction?.clearFilter()
  }

  useEffect(() => {
    if (getDate) {
      getDate?.(badgeLabel, date)
    }
  }, [date, badgeLabel, getDate])

  const onClearDates = (event: $TSMigrationFixMe) => {
    event.stopPropagation()
    setDate({
      [dateFilterKeys[0]]: "",
      [dateFilterKeys[1]]: "",
    })
    setLabelDate("")
    // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to pa...
    setBadgeLabel(false)
    setRangeDateOption("")
    setShowFilterMenu(false)
    if (
      [
        ROUTES.CONTABILIDAD_BALANCE,
        ROUTES.CONTABILIDAD_PERDIDAS_GANANCIAS,
        ROUTES.CONTABILIDAD_SUMAS_SALDOS,
      ].includes(location.pathname)
    ) {
      setIsFilterActive(false)
    }
    handleRemoveFilter?.([dateFilterKeys[0], dateFilterKeys[1]])
    getDate?.("Invalid date")
  }

  useEffect(() => {
    query === "" && setIsFilterActive(false)
  }, [query])

  const disableApplyButton = () => {
    // @ts-expect-error TS(2538): Type 'any[]' cannot be used as an index type.
    const startDateSelected = date?.[[dateFilterKeys[0]]] !== ""
    // @ts-expect-error TS(2538): Type 'any[]' cannot be used as an index type.
    const lastDateSelected = date?.[[dateFilterKeys[1]]] !== ""
    // @ts-expect-error TS(6133): 'regex' is declared but its value is never read.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const regex = new RegExp(
      `^${ROUTES.PRESTAMOS_DETAIL.replace(":id", ".+")}$`
    )

    if (
      [
        ROUTES.CONTABILIDAD_BALANCE,
        ROUTES.CONTABILIDAD_PERDIDAS_GANANCIAS,
        ROUTES.CONTABILIDAD_SUMAS_SALDOS,
      ].includes(location.pathname)
    ) {
      return !(startDateSelected && lastDateSelected && !applyAlwaysActive)
    }

    return (
      !applyAlwaysActive &&
      ((startDateSelected && !lastDateSelected) ||
        (!startDateSelected && lastDateSelected))
    )
  }
  const hideFilter = () => {
    setDate(preData.date)
    setRangeDateOption(preData.rangeDateOption)
    setRangeDatesFilter({
      // @ts-expect-error TS(2339): Property 'precioLowerLimit' does not exist on type...
      [dateFilterKeys[0]]: preData?.precioLowerLimit,
      // @ts-expect-error TS(2339): Property 'precioUpperLimit' does not exist on type...
      [dateFilterKeys[1]]: preData?.precioUpperLimit,
    })
    handleChangePrecioRange({
      value: [preData?.[importeFilterKeys[0]], preData?.[importeFilterKeys[1]]],
    })
    setSelectedOptions(preData.selectedOptions)
    setQuery(preData.query || "")
    setLabelDate(preData.labelDate)
    customFunction?.hideFilter()
    setShowFilterMenu(!showFilterMenu)
  }

  return (
    <div className='filter__container d-flex'>
      {isFilterActive || isCustomFilterActive ? (
        disableDateTag ? (
          <CustomButton
            type='text'
            className='ml-2 mr-2 filter_button primary'
            onClick={hide}
          >
            <FontAwesomeIcon icon={["fal", icon]} />
            <span className='px-3'>{badgeLabel}</span>
            <div
              className='filter-icon__container d-flex justify-content-end '
              onClick={onClearDates}
            >
              <FontAwesomeIcon icon={["fal", "xmark"]} />
            </div>
          </CustomButton>
        ) : (
          <CustomButton
            type='text'
            className='ml-2 mr-2 filter_button primary'
            onClick={hide}
          >
            <FontAwesomeIcon icon={["fal", icon]} />
            <span className='px-3'>{t("filtros.principalButtonLabel")}</span>
            <div className='filter-icon__container d-flex justify-content-end'>
              <FontAwesomeIcon
                icon={["fal", "xmark"]}
                onClick={onClearFilters}
              />
            </div>
          </CustomButton>
        )
      ) : (
        <Button
          // @ts-expect-error TS(2769): No overload matches this call.
          variant='outlined'
          onClick={openFilters}
          className='tw-h-10 tw-px-3 tw-flex tw-justify-evenly tw-bg-white tw-border-neutral-25 tw-rounded-md tw-text-text'
          aria-controls='popup_menu'
          aria-haspopup
          style={{ backgroundColor: buttonColor }}
        >
          <div>
            <FontAwesomeIcon
              className='px-2'
              icon={["fal", icon]}
            />
          </div>
          <span className='px-2'>{t("filtros.principalButtonLabel")}</span>
        </Button>
      )}
      {badgeLabel && !disableDateTag && seeButonDates && (
        <CustomButton
          type='text'
          className='ml-2 mr-2 filter_button primary'
          onClick={hide}
        >
          <FontAwesomeIcon icon={["fal", "calendar-lines"]} />
          <span className='px-3'>{badgeLabel}</span>
          <div className='filter-icon__container d-flex justify-content-end'>
            <FontAwesomeIcon
              icon={["fal", "xmark"]}
              onClick={onClearDates}
            />
          </div>
        </CustomButton>
      )}
      <AnimatePresence>
        <Modal
          header={t("filtros.title")}
          onHide={() => {
            hideFilter()
          }}
          visible={showFilterMenu}
          position='right'
          footer={
            <div className='filter-buttons position-bottom w-100'>
              <p onClick={onClearFilters}>{t("filtros.labelDelete")}</p>
              <CustomButton
                type='text'
                className='tw-ml-2 !tw-bg-primary tw-cursor-pointer'
                onClick={handleConfirmFilters}
                disabled={disableApplyButton()}
              >
                {t("filtros.labelApply")}
              </CustomButton>
            </div>
          }
        >
          {showFilterMenu && (
            <div
              className='filter_main-container w-100 h-100'
              // @ts-expect-error TS(2322): Type 'MutableRefObject<undefined>' is not assignab...
              ref={menuRef}
            >
              <div className='filter-content'>
                {children ? (
                  <>
                    <div className='filter-title'>
                      <h5>{customFilterTitle}</h5>
                    </div>
                    <div className='w-100'>
                      <div className='w-100'>{children}</div>
                    </div>
                  </>
                ) : null}
                {fechaFilterActive ? (
                  <FechaFilter
                    fechaDrodownActive={fechaDrodownActive}
                    onGetSelectValues={onGetSelectValues}
                    dateFilterKeys={dateFilterKeys}
                    rangeDateOption={rangeDateOption}
                    handleDate={handleDate}
                    handleCustomDate={handleCustomDate}
                    date={date}
                    dateKeys={dateFilterKeys}
                    preData={getFechasFilter(preDataFilter?.selectedOptions)}
                  />
                ) : null}
                {importeFilterActive ? (
                  <ImporteFilter
                    importeSliderActive={importeSliderActive}
                    precioLowerLimit={precioLowerLimit}
                    handleOnChangeLowerPrecioRange={
                      handleOnChangeLowerPrecioRange
                    }
                    handleOnChangeHigherPrecioRange={
                      handleOnChangeHigherPrecioRange
                    }
                    initialMinPrecioRange={
                      initialMinPrecioRange <= precioLowerLimit
                        ? initialMinPrecioRange
                        : precioLowerLimit
                    }
                    initialMaxPrecioRange={
                      initialMaxPrecioRange >= precioUpperLimit
                        ? initialMaxPrecioRange
                        : precioUpperLimit
                    }
                    preciosRange={preciosRange}
                    handleChangePrecioRange={handleChangePrecioRange}
                    precioUpperLimit={precioUpperLimit}
                    prePrecios={getImporteFilter(
                      preDataFilter?.selectedOptions
                    )}
                  />
                ) : null}
                {endCustomChildren && endCustomChildren}
              </div>
            </div>
          )}
        </Modal>
      </AnimatePresence>
    </div>
  )
}

export default FilterMenu
